/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAdministrativesRequestPayload } from '../../models/get-administratives-request-payload';
import { GetAdministrativesResponse } from '../../models/get-administratives-response';

export interface PostApiAdministrativeV1$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: GetAdministrativesRequestPayload
}

export function postApiAdministrativeV1$Json(http: HttpClient, rootUrl: string, params?: PostApiAdministrativeV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAdministrativesResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiAdministrativeV1$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAdministrativesResponse>;
    })
  );
}

postApiAdministrativeV1$Json.PATH = '/private/v1/companies';
